import { render } from "./TheDeliveryPoints.vue?vue&type=template&id=0971be0e"
import script from "./TheDeliveryPoints.vue?vue&type=script&lang=js"
export * from "./TheDeliveryPoints.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/application/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__